/* Zepto owns validation, artwork and adding the personalised line. This bridge only reads the finished cart. */
(() => {
  let refreshing = false;
  let queued = false;
  function recovery() {
    const parent = document.querySelector('.product-info') || document.querySelector('main');
    if (!parent) return;
    let status = document.getElementById('mr-cart-recovery');
    if (!status) { status = document.createElement('p');status.id='mr-cart-recovery';status.className='mr-cart-recovery';status.setAttribute('role','status');parent.append(status); }
    status.textContent = 'Your bag could not be displayed. ';
    const link=document.createElement('a');link.href=(window.Shopify?.routes?.root || '/')+'cart';link.className='link';link.textContent='View your bag';status.append(link);
  }
  async function refreshPersonalisedCart() {
    window.mrPersonalizerCartPending = false;
    if (refreshing) { queued = true; return; }
    refreshing = true;
    try {
      do {
        queued = false;
        const drawer = document.getElementById('cart-drawer');
        if (!drawer) throw new Error('No drawer');
        await customElements.whenDefined('cart-drawer');
        const root=window.Shopify?.routes?.root || '/';
        const sections=[drawer.dataset.mrSectionId];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const ids=[...new Set(sections.filter(Boolean))].slice(0,5);
        const responses=await Promise.all([
          fetch(root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}}),
          fetch(root+'?sections='+encodeURIComponent(ids.join(',')),{cache:'no-store',headers:{Accept:'application/json'}})
        ]);
        if (responses.some(response=>!response.ok)) throw new Error('Cart refresh failed');
        const [cart,rendered]=await Promise.all(responses.map(response=>response.json()));
        cart.sections=rendered;
        document.getElementById('mr-cart-recovery')?.remove();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
      } while (queued);
    } catch { recovery(); }
    finally { refreshing=false; }
  }
  document.addEventListener('moonreed:personalizer-added',refreshPersonalisedCart);
  document.addEventListener('cart-drawer:error',recovery);
  if (window.mrPersonalizerCartPending) refreshPersonalisedCart();
})();
